export default __webpack_public_path__ + "static/media/logo.f82847c9.png";